import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
import { seatPositionValidator } from './seat-position';
import { seatTypeValidator } from './seat-type';
export const seatValidator = Validator.object({
    id: nonEmptyStringValidator,
    areaCategoryId: nonEmptyStringValidator,
    position: seatPositionValidator,
    seatGroupIds: Validator.array({ items: nonEmptyStringValidator }),
    label: Validator.optional(nonEmptyStringValidator),
    rowLabel: nonEmptyStringValidator,
    type: seatTypeValidator
});
